export default __webpack_public_path__ + "4bd4794865ce666b6edb764b845fde4c.png";